const defaultState = {
  propertyTypes: [],
  shumaTypes: [],
  users: [],
  loading: false,
  error: false,
  errorMessage: null,
};

export const actionTypes = {
  getPropertyTypes: 'GET_PROPERTY_TYPES',
  getAllShumaTypes: 'GET_ALL_SHUMA_TYPES',
  getFirmUsers: 'GET_FIRM_USERS',
  catchError: 'CATCH_ERROR',
};

export const dataTableWithFiltersOptionsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.getPropertyTypes: {
      const {propertyTypes} = action.payload;
      return {
        ...state,
        propertyTypes,
        loading: false,
        error: false,
        errorMessage: null
      }
    }
    case actionTypes.getAllShumaTypes: {
      const {shumaTypes} = action.payload;
      return {
        ...state,
        shumaTypes,
        loading: false,
        error: false,
        errorMessage: null
      }
    }
    case actionTypes.getFirmUsers: {
      const {users} = action.payload;
      return {
        ...state,
        users,
        loading: false,
        error: false,
        errorMessage: null
      }
    }
    case actionTypes.catchError: {
      const error = `TABLE FILTERS OPTIONS: ${action.payload.error}`;
      return {...state, error};
    }
    default:
      return state;
  }
};


export const actions = {
  getPropertyTypes: (data) => ({
    type: actionTypes.getPropertyTypes,
    payload: data
  }),
  getAllShumaTypes: (data) => ({
    type: actionTypes.getAllShumaTypes,
    payload: data
  }),
  catchError: (error) => ({
    type: actionTypes.catchError,
    payload: error
  }),
};
